// extracted by mini-css-extract-plugin
module.exports = {"main":"PaySection_main__1oKap","price":"PaySection_price__cwdCg","oldPrice":"PaySection_oldPrice__3G2_X","priceEn":"PaySection_priceEn__3Iapt","btn":"PaySection_btn__1TYLy"};